import React from "react";
import styles from "./index.module.scss";

import { CompanyPageBid } from "../../../../hooks/slices/companySlice";

import { CodeUtil, CpvUtil } from "../../../../utils/codes";
import { TFunction } from "react-i18next";
import { StringUtil } from "../../../../utils/strings";
import { CodeType } from "../../../../types/code";

export interface TabPanelTendersFocusProps extends React.HTMLAttributes<HTMLDivElement> {
  bids: CompanyPageBid[];
  t: TFunction;
}
export const TabPanelTendersFocus: React.FC<TabPanelTendersFocusProps> = ({
    bids,
    t,
}) => {
    if (bids.length === 0) return <></>;
    let mainActivities: {code: string, count: number}[] = [];
    for(const bid of bids){
        let bidCpvRoots = bid.subjectCodes.map(CpvUtil.getRoot).filter(StringUtil.distinct);
        for(const cpvRoot of bidCpvRoots){
            let activity = mainActivities.find(a => a.code === cpvRoot);
            if (activity) activity.count++;
            else mainActivities.push({code: cpvRoot, count: 1});
        }
    }
    
    return (<div className={styles["tab-panel-tenders-focus"]}> { mainActivities
        .slice().sort((a, b) => b.count - a.count)
        .map((activity, index) => (
        <div key={index} className={styles['activity']}>
            {/*<div className={styles['cpv-icon']}>*/}
            {/*    <img src={*/}
            {/*        CpvUtil.getCpvIcon(activity.code)} */}
            {/*        alt={activity.code} */}
            {/*    />*/}
            {/*</div>*/}
            <div className={styles['cpv-description']}>
                {CodeUtil.getCodeWithTranslation(
                    {code: activity.code, type: CodeType.CPV}, 
                    t,
                )}
            </div>
            <div className={styles['cpv-count']}>
                ({activity.count})
            </div>
        </div>
    ))
    }</div>);
}